import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {Perspectives} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/layout/Perspective';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {FlowKeyboardShortcuts} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/FlowKeyboardShortcuts';
import {FlowTopBar} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/topBar/FlowTopBar';
import {RootLayoutView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/RootLayoutView';

const styles = require('./FlowEditor.less');
const cx = classnames.bind(styles);

@observer
export class FlowEditor extends React.Component<any, any>
{
    render():JSX.Element
    {
        const {flow, flowSimulation, perspective} = controllers.ui;

        const openFlow = flow.getOpenFlow();

        if( !openFlow )
        {
            return null;
        }

        const flowPerspective = perspective.getPerspective(Perspectives.FLOW_TAB);

        const simulation = flowSimulation.getForFlowEditor(openFlow.id);
        const isStoppedOrInitialNotRunning = !simulation || (simulation && flowSimulation.isStoppedOrInitialNotRunning(simulation.id));

        return (
            <FlowKeyboardShortcuts>
                <div className={cx('base')}>
                    <FlowTopBar />

                    <div className={cx('body', {isRunning: !isStoppedOrInitialNotRunning})}>
                        <RootLayoutView
                            className={cx('rootLayoutView')}
                            perspective={flowPerspective}
                        />
                    </div>
                </div>
            </FlowKeyboardShortcuts>
        );
    }
}
